import TargetModal from './TargetModal';

export default TargetModal;
